import GroupBase from "./GroupsBase";

class ConversionGroup extends GroupBase {
    constructor() {
        super({
            name: "Conversion",
            description: "",
        });
    }
}

export default ConversionGroup;
